export const fr = {
  passportVisa: {
  pageTitle: 'Passeports et Visas Hajj',
  pageSubtitle: 'Gestion des documents de passeports et de visas pour les pèlerins',
  downloadAllZip: 'Télécharger tout en ZIP',
  creatingZip: 'Création du fichier ZIP...',
  exportStatus: 'Statut de l\'exportation',
  exporting: 'Exportation en cours...',
  searchPlaceholder: 'Rechercher par nom, numéro de passeport, guide ou organisateur...',
  allOrganizers: 'Tous les organisateurs',
  allDocumentTypes: 'Tous les types de documents',
  passportOnly: 'Passeport uniquement',
  visaOnly: 'Visa uniquement',
  allStatuses: 'Tous les statuts',
  complete: 'Complet',
  missing: 'Manquant',
  activeFilters: 'Filtres actifs :',
  search: 'Recherche',
  organizer: 'Organisateur',
  status: 'Statut',
  documentType: 'Type de document',
  loadingStatuses: 'Chargement des statuts des documents...',
  documentsByCountry: 'Documents par pays',
  documentsByOrganizer: 'Documents par organisateur',
  noDataAvailable: 'Aucune donnée disponible',
  country: 'Pays',
  total: 'Total',
  pilgrim: 'Pèlerin',
  guideAndOrganizer: 'Guide et organisateur',
  document: 'Document',
  type: 'Type',
  actions: 'Actions',
  uploaded: 'Téléversé',
  notUploaded: 'Non téléversé',
  viewDocument: 'Voir le document',
  upload: 'Téléverser',
  view: 'Voir',
  noDocumentsMatch: 'Aucun document ne correspond aux critères de recherche',
  noDocumentsAvailable: 'Aucun document disponible',
  showing: 'Affichage de',
  of: 'sur',
  documents: 'documents',
  loadingPilgrimData: 'Chargement des données des pèlerins...',
  previous: 'Précédent',
  next: 'Suivant',
  page: 'Page',
  exportSuccess: 'Exportation réussie',
  exportError: 'Échec de l\'exportation',
  downloadSuccess: 'Documents téléchargés avec succès',
  downloadError: 'Échec de la création du fichier ZIP',
  uploadSuccess: (type: string) => `${type} téléversé avec succès`,
  uploadError: 'Échec du téléversement du document',
  failedToLoadStatuses: 'Échec du chargement des statuts des documents',
  deleteSuccess: 'Document supprimé avec succès',
  deleteError: 'Échec de la suppression du document'
},
  accommodationChart: {
    checkInOutTitle: 'Calendrier des arrivées et départs',
    loadData: 'Charger les données',
    export: 'Exporter les données',
    exportSuccess: 'Données exportées avec succès',
    exportError: 'Échec de l\'exportation des données',
    loading: 'Chargement en cours...',
    noData: 'Aucune donnée disponible',
    clickToLoad: 'Cliquez pour charger les données et voir les statistiques',
    loadError: 'Échec du chargement des données',
    checkIn: 'Arrivée',
    checkOut: 'Départ',
    myCheckIn: 'Mes arrivées',
    myCheckOut: 'Mes départs',
    accommodated: 'Hébergés',
    myAccommodated: 'Mes hébergés',
    totalCheckIns: 'Total arrivées',
    totalCheckOuts: 'Total départs',
    totalAccommodated: 'Total hébergés',
    myTotalAccommodated: 'Total mes hébergés',
    peakOn: 'Pic le',
    yours: 'à vous'
  },
  roomTypesChart: {
    all: 'Tous types de chambre',
    double: 'Double',
    triple: 'Triple',
    quadruple: 'Quadruple'
  },
  bulkLinkStatus: {
    title: 'Résultats du Lien en Masse',
    backToGuide: 'Retour à la Page du Guide',
    export: 'Exporter les Résultats',
    processing: 'Traitement du fichier...',
    rowsProcessed: 'Lignes traitées',
    totalProcessed: 'Total traité',
    successful: 'Réussi',
    failed: 'Échoué',
    successRate: 'Taux de réussite',
    identifier: 'Identifiant',
    pilgrimName: 'Nom du Pèlerin',
    guide: 'Guide',
    status: 'Statut',
    errors: 'Erreurs',
    statusSuccess: 'Succès',
    statusError: 'Erreur',
    statusProcessing: 'En cours de traitement',
  },
  bulkLink: {
    validation: {
      invalidIdentifierType: 'Type d’identifiant invalide',
      identifierRequired: 'Identifiant requis',
      guideRequired: 'Nom du guide requis',
      pilgrimNotFound: 'Pèlerin non trouvé',
      processingInProgress: 'Traitement du pèlerin en cours',
      duplicatePilgrim: 'Le pèlerin apparaît plus d’une fois dans le fichier',
      guideNotFound: 'Guide non trouvé',
    },
  },
  verificationWizardPage: {
    errors: {
      checkVerification:
        "Échec de la vérification de l'état de la vérification",
      userNotFound: 'Aucune information utilisateur trouvée',
      verificationFailed: 'Échec de la vérification',
    },
    success: {
      verificationSubmitted: 'Vérification envoyée avec succès',
    },
  },
  wizardProgress: {
    steps: {
      terms: 'Conditions',
      info: 'Informations',
      contract: 'Contrat',
      bank: 'Informations bancaires',
    },
  },
  bankStep: {
    headers: {
      bankInformation: 'Informations bancaires',
    },
    labels: {
      bankName: 'Nom de la banque',
      accountNumber: 'Numéro de compte',
      swiftCode: 'Code SWIFT / BIC',
      bankBranch: 'Agence bancaire',
      ifscCode: 'Code RTGS / NEFT / IFSC',
    },
    placeholders: {
      bankName: 'Entrez le nom de la banque',
      accountNumber: 'Entrez votre numéro de compte',
      swiftCode: 'Exemple : BOFAUS3N',
      bankBranch: "Entrez le nom de l'agence",
      ifscCode: 'Exemple : ABCD0123456',
    },
    errors: {
      bankNameRequired: 'Le nom de la banque est requis',
      accountNumberInvalid:
        'Format du numéro de compte invalide (10-20 chiffres)',
      swiftCodeInvalid: 'Format du code SWIFT / BIC invalide',
      bankBranchRequired: "Le nom de l'agence est requis",
      ifscCodeInvalid: 'Format du code IFSC invalide',
    },
    buttons: {
      back: 'Retour',
      submit: 'Soumettre',
    },
    validationMessages: {
      requiredField: 'Ce champ est requis',
      validAccountNumber:
        'Le numéro de compte doit comporter entre 10 et 20 chiffres',
      validSwiftCode:
        'Le code SWIFT doit être composé de 6 lettres suivies de 2 ou 3 chiffres/lettres',
    },
    success: {
      formSubmitted: 'Données envoyées avec succès',
    },
  },
  contractStep: {
    headers: {
      contractReview: 'Révision du contrat',
      contractName: 'Contrat de services marketing',
    },
    subHeaders: {
      reviewMessage: 'Veuillez revoir le contrat avant de signer',
    },
    labels: {
      digitalSignature: 'Signature numérique (tapez votre nom complet)',
    },
    placeholders: {
      signature: 'Tapez votre nom complet comme signature',
    },
    buttons: {
      viewContract: 'Voir le modèle de contrat',
      generateContract: 'Générer le contrat',
      generatingContract: 'Génération du contrat...',
      downloadContract: 'Télécharger le contrat signé',
      next: 'Suivant',
      submit: 'Soumettre',
      back: 'Retour',
    },
    success: {
      contractGenerated: 'Contrat généré avec succès',
    },
    errors: {
      noSignature: 'Veuillez fournir votre signature numérique',
      contractGeneration:
        'Échec de la génération du contrat, veuillez réessayer',
    },
  },
  infoStep: {
    title: 'Informations personnelles',
    labels: {
      fullName: "Nom complet (tel qu'indiqué sur le passeport)",
      passportNumber: 'Numéro du passeport',
      passportIssuanceDate: 'Date de délivrance du passeport',
      nationality: 'Nationalité',
      country: 'Pays de résidence',
      mobileNumber: 'Numéro de téléphone portable',
      email: 'Email',
      agent: "Nom de l'agent/entreprise",
    },
    placeholders: {
      fullName: 'Entrez votre nom complet',
      passportNumber: 'Entrez le numéro de passeport',
      nationality: 'Entrez la nationalité',
      country: 'Entrez le pays de résidence',
      mobileNumber: '+1234567890',
      email: 'exemple@domaine.com',
      agent: "Entrez le nom de l'entreprise",
    },
    errors: {
      fullName: 'Le nom complet doit comporter au moins 3 lettres',
      passportNumber: 'Format du numéro de passeport invalide',
      issuanceDateRequired: 'La date de délivrance est requise',
      invalidDate: 'Format de la date invalide',
      futureDate: 'La date de délivrance ne peut pas être dans le futur',
      oldDate: 'La date de délivrance ne peut pas être antérieure à 10 ans',
      nationalityRequired: 'La nationalité est requise',
      countryRequired: 'Le pays de résidence est requis',
      invalidMobile: 'Format du numéro de portable invalide',
      invalidEmail: "Format de l'email invalide",
      agentRequired: "Le nom de l'agent/entreprise est requis",
    },
    buttons: {
      back: 'Retour',
      next: 'Suivant',
    },
  },
  terms: {
    title: 'Déclaration et Engagement',
    acknowledgment: "Je soussigné, reconnais et m'engage à ce qui suit :",
    compliance:
      "Respect de tous les termes de l'accord des services marketing signé avec Ithraa Alkhair.",
    provideServices: 'Fournir des services marketing comme suit :',
    promotePackages:
      'Promouvoir les caractéristiques des packages et services via des moyens numériques, les médias sociaux, des événements et des salons.',
    encouragePilgrims:
      "Encourager les pèlerins à s'inscrire sur la plateforme Nusuk et suivre de près les inscriptions.",
    submitList:
      "Soumettre une liste des pèlerins inscrits sur la plateforme Nusuk avant le début de la phase d'achat des packages.",
    adhereTo: 'Se conformer à ce qui suit :',
    uploadData:
      'Télécharger les données des pèlerins dans les délais prescrits.',
    ensureAccuracy:
      "Garantir la précision des données et éviter les doublons ou correspondances avec les données d'un autre guide.",
    clearMessages:
      'Utiliser des messages marketing clairs qui respectent les valeurs religieuses et culturelles.',
    noComplaints:
      "Assurer qu'il n'y a pas de plaintes ou de problèmes concernant les services fournis.",
    legalResponsibility:
      "Assumer l'entière responsabilité légale et financière en cas de violation des engagements ci-dessus.",
    agreeTerms: "J'accepte les termes et conditions ci-dessus",
    next: 'Suivant',
  },
  verification: {
    detailsTitle: 'Détails de la vérification',
    created: 'Créé',
    lastUpdated: 'Dernière mise à jour',
    rejectionReason: 'Raison du rejet',
    viewContract: 'Voir le contrat',
    delete: 'Supprimer',
    deleteSuccess: 'Vérification supprimée avec succès',
    deleteError: 'Échec de la suppression de la vérification',
    userType: "Type d'utilisateur",
    createdAt: 'Créé le',
    personalInfo: 'Informations personnelles',
    bankInfo: 'Informations bancaires',
    digitalSignature: 'Signature numérique',
    bankName: 'Nom de la banque',
    accountNumber: 'Numéro de compte',
    swiftCode: 'Code SWIFT',
    bankBranch: 'Agence bancaire',
    ifscCode: 'Code IFSC',
    noBankInfo: 'Aucune information bancaire fournie',
    bankInfoUpdated: 'Informations bancaires mises à jour avec succès',
    bankInfoError: 'Échec de la mise à jour des informations bancaires',
    viewSignedContract: 'Voir le contrat signé',
  },
  verificationApproval: {
    statuses: {
      approved: 'Approuvé',
      rejected: 'Rejeté',
      pending: 'En attente',
    },
    userTypes: {
      guide: 'Guide',
      organizer: 'Organisateur',
    },
    createdAt: 'Date de création',
    buttons: {
      viewContract: 'Voir le contrat',
      delete: 'Supprimer',
      approve: 'Approuver',
      reject: 'Rejeter',
      export: 'Exporter',
      downloadContracts: 'Télécharger les contrats',
      cancel: 'Annuler',
    },
    bankInfo: {
      title: 'Informations bancaires',
      bankName: 'Nom de la banque',
      accountNumber: 'Numéro de compte',
      swiftCode: 'Code SWIFT',
      bankBranch: 'Agence bancaire',
      ifscCode: 'Code IFSC',
    },
    filters: {
      searchPlaceholder: 'Chercher...',
      allStatuses: 'Tous les statuts',
      pending: 'En attente',
      approved: 'Approuvé',
      rejected: 'Rejeté',
      allTypes: 'Tous les types',
      guides: 'Guides',
      organizers: 'Organisateurs',
      activeFilters: 'Filtres actifs:',
      search: 'Recherche',
      status: 'Statut',
      type: 'Type',
    },
    dialog: {
      approveTitle: 'Approuver la vérification',
      rejectTitle: 'Rejeter la vérification',
      deleteTitle: 'Supprimer la vérification',
      approveMessage: 'Êtes-vous sûr de vouloir approuver cette vérification ?',
      rejectMessage: 'Êtes-vous sûr de vouloir rejeter cette vérification ?',
      rejectionReasonLabel: 'Raison du rejet',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer cette vérification pour {name} ? Cette action est irréversible.',
    },
  },
  pilgrimSelector: {
    searchPlaceholder: 'Recherchez par nom, passeport ou pays...',
    passport: 'Passeport',
    arrivalDate: "Date d'arrivée",
    noResults: 'Aucun pèlerin correspondant trouvé',
    startSearch: 'Commencez à rechercher un pèlerin...',
  },
  header: {
    refresh: 'Rafraîchir',
    refreshing: 'Rafraîchissement en cours...',
    refreshSuccess: 'Données mises à jour avec succès',
    refreshError: 'Échec de la mise à jour des données',
  },
  verificationPage: {
    verifying: 'Vérification en cours...',
    verifyNow: 'Vérifier maintenant',
    clickButton:
      'Cliquez sur le bouton pour vérifier la corrélation des données entre les pèlerins, les forfaits et les voyages',
  },
  team: {
    title: 'Équipe',
    addMember: 'Ajouter un membre',
  },
  evidenceViewModal: {
    title: 'Preuve du guide',
    noEvidence: 'Aucune preuve soumise',
    textEvidence: 'Texte de la preuve',
    imageEvidence: 'Image soumise',
    submittedAt: 'Date de soumission',
    updatedAt: 'Dernière mise à jour',
  },
  disputeCard: {
    selectGuide: 'Un guide doit être sélectionné',
    resolveSuccess: 'Conflit résolu avec succès',
    resolveError: 'Échec de la résolution du conflit',
    emailSubject:
      "Important : Vérification du guide requise - Support technique d'Athra Al-Khayrat",
    emailBodyPart1: 'Cher',
    emailBodyPart2:
      "Nous vous contactons depuis le support technique d'Athra Al-Khayrat concernant vos arrangements pour le Hajj.",
    emailBodyPart3:
      'Nous avons reçu des informations contradictoires concernant votre guide assigné. Selon nos dossiers, les deux suivants prétendent être votre guide officiel.',
    emailBodyPart4: "qu'ils sont votre guide officiel.",
    emailBodyPart5:
      'Pouvez-vous confirmer qui est votre guide assigné ? Cette information est cruciale pour garantir que le service soit fourni correctement pendant votre voyage pour le Hajj.',
    emailBodyPart6: 'Cordialement,',
    emailBodyPart7: "Équipe de support technique d'Athra Al-Khayrat",
    emailNotAvailable: 'Email non disponible',
    whatsAppMessage1: 'Cher',
    whatsAppMessage2:
      "L'équipe de support technique d'Athra Al-Khayrat vous contacte concernant vos arrangements pour le Hajj.",
    whatsAppMessage3:
      'Nous avons reçu des informations contradictoires concernant votre guide assigné. Selon nos dossiers, les deux suivants prétendent être votre guide officiel.',
    whatsAppMessage4: "qu'ils sont votre guide officiel.",
    whatsAppMessage5:
      'Pouvez-vous confirmer qui est votre guide assigné ? Cette information est cruciale pour garantir que le service soit fourni correctement pendant votre voyage pour le Hajj.',
    whatsAppMessage6: 'Cordialement,',
    whatsAppMessage7: "Équipe de support technique d'Athra Al-Khayrat",
    phoneNotAvailable: 'Numéro de téléphone non disponible',
    sendEmail: 'Envoyer un e-mail',
    sendWhatsApp: 'Envoyer par WhatsApp',
    countryNotAvailable: 'Pays non disponible',
    passport: 'Passeport',
    viewEvidence: 'Voir la preuve',
    resolveDispute: 'Résoudre le conflit',
    requestDate: 'Date de la demande',
  },
  disputesList: {
    noDisputes: 'Aucun conflit ne correspond aux filtres sélectionnés',
  },
  disputesPage: {
    header: 'Conflits',
    description:
      'Gestion des conflits de propriété des pèlerins entre les guides',
  },
  linkingStats: {
    totalPilgrims: 'Total des pèlerins',
    countries: 'Nombre de pays',
    approved: 'Liaison approuvée',
    pending: 'En attente',
    rejected: 'Rejeté',
  },
  linkingTableRow: {
    status: {
      approved: 'Liaison approuvée',
      rejected: 'Rejeté',
      pending: 'En attente',
      waitingIdentification: 'En attente d’identification',
    },
    labels: {
      passport: 'Passeport',
    },
  },
  linkingStatusPage: {
    header: 'État de la liaison',
    description:
      "Suivi de l'état de la liaison entre les guides et les pèlerins",
  },
  verificationHeader: {
    header: 'Vérification de la liaison',
    description:
      'Vérifiez la liaison des données entre les pèlerins, les forfaits et les voyages',
  },
  flightsPage: {
    header: 'Vols',
    downloadTemplate: 'Exemple de téléchargement',
    addFlights: 'Ajouter des vols',
    deleteAll: 'Supprimer tous les vols',
    uploadError: 'Une erreur est survenue lors du téléchargement des données',
    deleteSuccess: 'Tous les vols ont été supprimés avec succès',
    deleteError: 'Une erreur est survenue lors de la suppression des vols',
    deleteAllTitle: 'Supprimer tous les vols',
    deleteAllMessage:
      'Êtes-vous sûr de vouloir supprimer tous les vols ? Cette action est irréversible.',
    confirmDelete: 'Supprimer tout',
    cancel: 'Annuler',
  },
  packagesPage: {
    header: 'Forfaits Hajj',
    downloadTemplate: 'Exemple de téléchargement',
    addPackages: 'Ajouter des forfaits',
    deleteAll: 'Supprimer tous les forfaits',
    uploadError: 'Une erreur est survenue lors du téléchargement des données',
    deleteSuccess: 'Tous les forfaits ont été supprimés avec succès',
    deleteError: 'Une erreur est survenue lors de la suppression des forfaits',
    deleteAllTitle: 'Supprimer tous les forfaits',
    deleteAllMessage:
      'Êtes-vous sûr de vouloir supprimer tous les forfaits ? Cette action est irréversible.',
    confirmDelete: 'Supprimer tout',
    cancel: 'Annuler',
  },
  pilgrimsPage: {
    header: 'Informations sur les pèlerins',
    downloadTemplate: 'Exemple de téléchargement',
    addPilgrims: 'Ajouter des pèlerins',
    deleteAll: 'Supprimer tous les pèlerins',
    uploadError: 'Une erreur est survenue lors du téléchargement des données',
    deleteSuccess: 'Tous les pèlerins ont été supprimés avec succès',
    deleteError: 'Une erreur est survenue lors de la suppression des pèlerins',
    deleteAllTitle: 'Supprimer tous les pèlerins',
    deleteAllMessage:
      'Êtes-vous sûr de vouloir supprimer tous les pèlerins ? Cette action est irréversible.',
    confirmDelete: 'Supprimer tout',
    cancel: 'Annuler',
  },
  adminDashboard: {
    morningGreeting: 'Bonjour',
    afternoonGreeting: 'Bon après-midi',
    eveningGreeting: 'Bonsoir',
    defaultUserName: 'Administrateur système',
    welcomeMessage:
      'Bienvenue dans le système de gestion des forfaits Hajj intégré',
    makkah: 'La Mecque',
    madinah: 'Médine',
    mina: 'Mina',
    holyCity: 'La ville sainte',
    prophetMosque: 'Mosquée du Prophète',
    pilgrimsCamp: 'Camps des pèlerins',
    managePilgrims: 'Gérer les pèlerins',
    movementSchedule: 'Plan de mouvement',
    flights: 'Vols',
    accommodation: 'Hébergement',
  },
  organizerFinance: {
    importantNotice: 'Avis Important',
    lastUpdated: 'Dernière mise à jour',
    disclaimerText: 'Tous les montants et paiements affichés sont susceptibles d\'être modifiés sans responsabilité légale ni préavis. Cette déclaration n\'est pas définitive et ne représente pas une obligation financière de la part d\'Ithraa Al-Khair.',
    title: 'Finance des Organisateurs',
    subtitle:
      'Gérer et suivre les paiements des organisateurs en fonction de la propriété des pèlerins',
    totalPilgrims: 'Total des Pèlerins',
    matchingPilgrims: 'Pèlerins Correspondants',
    mismatchedPilgrims: 'Pèlerins Non Correspondants',
    totalAmount: 'Montant Total',
    bonusAmount: 'Montant du Bonus',
    savedAmount: 'Montant Économisé',
    pilgrimName: 'Nom du Pèlerin',
    passportNumber: 'Numéro de Passeport',
    assignedGuide: 'Guide Assigné',
    owner: 'Propriétaire',
    paymentType: 'Type de Paiement',
    amount: 'Montant',
    status: 'Statut',
    matching: 'Correspondant',
    mismatched: 'Non Correspondant',
    fullPayment: 'Paiement Complet',
    guidancePayment: 'Paiement de Guidage',
    marketingPayment: 'Paiement Marketing',
    summary: 'Résumé',
    baseAmount: 'Montant de Base',
    exportReport: 'Exporter le Rapport',
    financialStats: {
      totalAmount: 'Montant Total',
      pilgrimsDistribution: 'Répartition des Pèlerins',
      savedAmount: 'Montant Économisé',
      includesBonus: 'Inclut {{bonusAmount}} SAR de bonus',
    },
    tableHeaders: {
      pilgrim: 'Pèlerin',
      passport: 'Passeport',
      guide: 'Guide',
      owner: 'Propriétaire',
      paymentType: 'Type de Paiement',
      amount: 'Montant (SAR)',
    },
  },
  common: {
    loading: 'Chargement...',
    error: 'Échec du chargement des données requises',
  },
  pilgrimOwnership: {
    title: 'Propriété des Pèlerins',
    subtitle: 'Gérer et déterminer la propriété réelle des pèlerins',
  },
  filters: {
    searchPlaceholder: 'Rechercher par nom ou numéro de passeport...',
    allCountries: 'Tous les Pays',
    allGenders: 'Tous les Genres',
    male: 'Homme',
    female: 'Femme',
    activeFilters: 'Filtres Actifs:',
    searchLabel: 'Recherche:',
    countryLabel: 'Pays:',
    genderLabel: 'Genre:',
  },
  tableHeaders: {
    pilgrim: 'Pèlerin',
    assignedGuide: 'Guide Assigné',
    realGuide: 'Guide Nusuk',
    ownership: 'Propriété du Pèlerin',
    compatibility: 'Compatibilité',
    passport: 'Passeport:',
    noGuide: 'Aucun',
    selectRealGuide: 'Sélectionner un Guide Nusuk...',
    selectOwner: 'Sélectionner un Propriétaire...',
  },
  toasts: {
    realGuideUpdated: 'Guide Nusuk mis à jour avec succès',
    realGuideUpdateFailed: 'Échec de la mise à jour du guide Nusuk',
    ownershipUpdated: 'Propriété du pèlerin mise à jour avec succès',
    ownershipUpdateFailed: 'Échec de la mise à jour de la propriété du pèlerin',
  },
  compatibility: {
    match: 'Correspond',
    mismatch: 'Ne Correspond Pas',
  },
  pilgrimGuideStore: {
    errors: {
      pilgrimNotFound: 'Aucun pèlerin trouvé avec ce numéro de passeport',
      linkFailed: 'Échec de la liaison du pèlerin au guide',
      deleteFailed: 'Échec de la suppression du lien',
    },
    success: {
      linkSuccess: 'Pèlerin lié au guide avec succès',
      deleteSuccess: 'Lien supprimé avec succès',
    },
  },
  pilgrimsStore: {
    success: {
      uploadPilgrims: '{count} pèlerins ajoutés avec succès',
    },
    errors: {
      uploadPilgrims: "Échec de l'ajout des pèlerins",
      deletePilgrim: 'Échec de la suppression du pèlerin',
      deleteAll: 'Échec de la suppression de tous les pèlerins',
      searchPilgrims: 'Échec de la recherche des pèlerins',
    },
  },
  addSuspensionModal: {
    title: 'Ajouter une nouvelle suspension',
    labels: {
      suspensionType: 'Type de suspension',
      hotel: 'Hôtel',
      selectHotel: 'Sélectionner un hôtel',
      reason: 'Raison',
      duration: 'Durée',
      temporary: 'Temporaire',
      permanent: 'Permanent',
      expiryDate: "Date d'expiration",
    },
    suspensionTypes: {
      linking: 'Suspension du service de liaison',
      allAccommodation: 'Suspension de tous les hébergements',
      specificHotel: "Suspension d'un hôtel spécifique",
      campAccommodation: "Suspension de l'hébergement en camp",
    },
    buttons: {
      cancel: 'Annuler',
      addSuspension: 'Ajouter une suspension',
      adding: 'Ajout en cours...',
    },
    errors: {
      allFieldsRequired: 'Tous les champs sont obligatoires',
      expiryDateRequired: "Veuillez sélectionner une date d'expiration",
      suspensionAddFailed: "Échec de l'ajout de la suspension",
    },
    success: {
      suspensionAdded: 'Suspension ajoutée avec succès',
    },
  },
  addBanModal: {
    title: 'Ajouter une nouvelle interdiction',
    labels: {
      userType: "Type d'utilisateur",
      guide: 'Guide',
      organizer: 'Organisateur',
      selectUser: 'Sélectionner',
      banType: "Type d'interdiction",
      reason: 'Raison',
      duration: 'Durée',
      temporary: 'Temporaire',
      permanent: 'Permanent',
      expiryDate: "Date d'expiration",
    },
    banTypes: {
      full: 'Interdiction totale',
      accommodation: "Interdiction d'hébergement",
      linking: 'Interdiction de liaison',
      camp: 'Interdiction de camp',
    },
    buttons: {
      cancel: 'Annuler',
      addBan: 'Ajouter une interdiction',
      adding: 'Ajout en cours...',
    },
    errors: {
      allFieldsRequired: 'Tous les champs sont obligatoires',
      expiryDateRequired: "Veuillez sélectionner une date d'expiration",
      banAddFailed: "Échec de l'ajout de l'interdiction",
    },
    success: {
      banAdded: 'Interdiction ajoutée avec succès',
    },
  },
  campAccommodation: {
    errors: {
      serviceSuspended:
        "Le service d'hébergement en camp est actuellement suspendu",
      notAuthenticated: "Vous n'êtes pas authentifié",
      userBanned:
        "Vous êtes interdit d'utiliser le service d'hébergement en camp",
      pilgrimNotFound: 'Aucun pèlerin trouvé avec ce numéro de passeport',
      noGuideLinked: "Le pèlerin n'est lié à aucun guide",
      noPermission: "Vous n'avez pas la permission d'effectuer cette action",
      tableNotFound: "Table d'hébergement non trouvée",
      tentNotFound: 'Tente non trouvée',
      hallNotFound: 'Salle non trouvée',
      genderMismatch:
        "Impossible d'assigner le pèlerin à cette salle en raison d'une incompatibilité de genre",
      notAuthorized: "Vous n'êtes pas autorisé à effectuer cette action",
    },
    header: {
      title: 'Hébergement en camp',
      subtitle:
        'Gérer l’hébergement des pèlerins dans les camps de Mina et Arafat',
    },
    addTableButton: 'Ajouter un tableau d’hébergement',
    stats: {
      totalCamps: 'Total des camps',
      occupiedTents: 'Tentes occupées',
      totalCapacity: 'Capacité totale',
      occupancyRate: 'Taux d’occupation',
    },
    noTablesMessage: 'Aucun tableau d’hébergement disponible',
  },
  bansManagement: {
    header: {
      title: 'Gestion des interdictions et suspensions',
      subtitle:
        "Gérer les interdictions d'utilisateurs et les suspensions de services",
    },
    buttons: {
      addBan: 'Ajouter une nouvelle interdiction',
      addSuspension: 'Suspendre le service',
    },
    stats: {
      activeBans: 'Interdictions actives',
      expiredBans: 'Interdictions expirées',
      activeSuspensions: 'Suspensions actives',
      totalActions: 'Total des actions',
    },
    disputeBans: {
      title: 'Interdictions de litiges',
      bannedFrom: 'Interdit de traiter avec le pèlerin',
      noBans: 'Aucune interdiction de litige trouvée',
    },
    activeBans: {
      title: 'Interdictions actives',
      guide: 'Guide',
      organizer: 'Organisateur',
      expiresOn: 'Expire le',
      permanentBan: 'Interdiction permanente',
      noBans: 'Aucune interdiction active trouvée',
    },
    activeSuspensions: {
      title: 'Suspensions actives',
      linking: 'Suspension du service de liaison',
      allAccommodation: 'Suspension de tous les hébergements',
      specificHotel: 'Hôtel',
      campAccommodation: "Suspension de l'hébergement en camp",
      by: 'Par',
      expiresOn: 'Expire le',
      permanentSuspension: 'Suspension permanente',
      noSuspensions: 'Aucune suspension active trouvée',
    },
    confirmDialog: {
      deactivateBanTitle: "Désactiver l'interdiction",
      deactivateBanMessage:
        'Êtes-vous sûr de vouloir désactiver cette interdiction ?',
      deactivateSuspensionTitle: 'Désactiver la suspension',
      deactivateSuspensionMessage:
        'Êtes-vous sûr de vouloir désactiver cette suspension ?',
      deleteBanTitle: "Supprimer l'interdiction",
      deleteBanMessage:
        'Êtes-vous sûr de vouloir supprimer cette interdiction définitivement ?',
      deleteSuspensionTitle: 'Supprimer la suspension',
      deleteSuspensionMessage:
        'Êtes-vous sûr de vouloir supprimer cette suspension définitivement ?',
      removeDisputeBanTitle: "Supprimer l'interdiction de litige",
      removeDisputeBanMessage:
        "Êtes-vous sûr de vouloir supprimer l'interdiction du guide",
      from: 'de',
      confirmText: 'Confirmer',
      cancelText: 'Annuler',
    },
    success: {
      removeDisputeBan: 'Interdiction supprimée avec succès',
      deactivateBan: 'Interdiction désactivée avec succès',
      deactivateSuspension: 'Suspension désactivée avec succès',
      deleteBan: 'Interdiction supprimée avec succès',
      deleteSuspension: 'Suspension supprimée avec succès',
    },
    errors: {
      fetchDisputeBans: 'Échec de la récupération des interdictions de litiges',
      removeDisputeBan: "Échec de la suppression de l'interdiction",
      deactivateBan: "Échec de la désactivation de l'interdiction",
      deactivateSuspension: 'Échec de la désactivation de la suspension',
      deleteBan: "Échec de la suppression de l'interdiction",
      deleteSuspension: 'Échec de la suppression de la suspension',
    },
  },
  accommodationLogs: {
    header: 'Journal des Activités',
    subheader: "Suivi des activités d'hébergement dans les hôtels",
    searchPlaceholder: 'Rechercher...',
    filters: {
      allHotels: 'Tous les Hôtels',
      allActions: 'Toutes les Actions',
      allRoles: 'Tous les Rôles',
      assign: 'Assigner',
      remove: 'Retirer',
      admin: 'Administrateur',
      guide: 'Guide',
      organizer: 'Organisateur',
      search: 'Rechercher',
      hotel: 'Hôtel',
      action: 'Action',
      role: 'Rôle',
    },
    activeFilters: 'Filtres Actifs:',
    logActions: {
      assign: 'Assigné',
      remove: 'Retiré',
    },
    logDetails: {
      pilgrimInfo: 'Informations Pèlerin',
      accommodationInfo: 'Informations Hébergement',
      room: 'Chambre',
      bed: 'Lit',
      performedBy: 'Effectué par:',
    },
    noLogs: 'Aucun journal ne correspond aux filtres sélectionnés',
  },
  PilgrimGuide: {
    messages: {
      deleteSuccess: 'Le lien a été supprimé avec succès',
      deleteError: 'Échec de la suppression du lien',
    },
    errors: {
      deletePermission: 'Vous n’avez pas la permission de supprimer ce lien',
      invalidLinkId: 'ID de lien invalide',
      noDispute: 'Aucun litige disponible pour soumettre une preuve',
    },
    confirmDialog: {
      deleteTitle: 'Supprimer le lien',
      disputeMessage:
        'La suppression de ce lien mettra fin au litige et donnera les droits à l’autre guide. Êtes-vous sûr de vouloir supprimer le lien pour le pèlerin {name} ?',
      defaultMessage:
        'Êtes-vous sûr de vouloir supprimer le lien pour le pèlerin {name} ?',
      deleting: 'Suppression en cours...',
      delete: 'Supprimer',
      cancel: 'Annuler',
    },
  },
  evidenceModal: {
    title: 'Soumettre une preuve',
    textLabel: 'Texte de la preuve',
    textPlaceholder: 'Entrez les détails de la preuve ici...',
    textRequiredError: 'Le texte de la preuve est requis',
    imageLabel: 'Image de la preuve (optionnelle)',
    uploadButton: 'Téléverser un fichier',
    dragAndDrop: 'ou glisser-déposer',
    fileRequirements: 'PNG, JPG jusqu’à 5 Mo',
    fileSizeError: 'La taille du fichier doit être inférieure à 5 Mo',
    uploadError: 'Échec du téléversement de l’image',
    uploadWaitError: 'Veuillez attendre la fin du téléversement de l’image',
    uploadingText: 'Téléversement de l’image en cours...',
    cancelButton: 'Annuler',
    submitButton: 'Soumettre la preuve',
    savingButton: 'Enregistrement en cours...',
    submitSuccess: 'Preuve soumise avec succès',
    submitError: 'Échec de la soumission de la preuve',
  },
  linkPilgrimToGuideAction: {
    banError:
      'Vous ne pouvez pas lier ce pèlerin en raison d’un bannissement d’un litige précédent',
    alreadyLinkedError: 'Ce pèlerin est déjà lié à vous',
    linkError: 'Échec de la liaison du pèlerin au guide',
    waitingIdentificationExists: 'Ce pèlerin est déjà en attente d’identification',
    waitingIdentificationName: 'En attente d’identification',
  },
  deleteLinkAction: {
    linkNotFound: 'Lien introuvable',
    deleteError: 'Échec de la suppression du lien',
    hotelAccommodationError:
      'Impossible de supprimer le pèlerin car il est logé à l’hôtel {hotelName} chambre {roomNumber}',
    campAccommodationError:
      'Impossible de supprimer le pèlerin car il est logé au camp {campName} tente {tentNumber} salle {hallNumber}',
  },
  activeFilters: {
    activeFiltersLabel: 'Filtres actifs :',
    searchLabel: 'Recherche :',
    statusLabel: 'Statut :',
    countryLabel: 'Pays :',
    statusApproved: 'Approuvé',
    statusPending: 'En attente',
    statusDisputed: 'En litige',
    statusRejected: 'Rejeté',
    statusWaitingIdentification: 'En attente d’identification',
  },
  resetPasswordModal: {
    title: 'Changer le mot de passe',
    newPasswordLabel: 'Nouveau mot de passe',
    confirmPasswordLabel: 'Confirmer le mot de passe',
    cancelButton: 'Annuler',
    saveButton: 'Enregistrer',
    savingButton: 'Enregistrement en cours...',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordLengthError: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordChangeSuccess: 'Mot de passe changé avec succès',
    passwordChangeError: 'Échec du changement de mot de passe',
  },
  campAccommodationTable: {
    exportSuccess: 'Données d’hébergement exportées avec succès',
    exportError: 'Échec de l’exportation des données d’hébergement',
    deleteSuccess: 'Tableau d’hébergement supprimé avec succès',
    deleteError: 'Échec de la suppression du tableau d’hébergement',
    deleteTitle: 'Supprimer le tableau d’hébergement',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer le tableau ?',
    deleteButton: 'Supprimer le tableau',
    confirmDelete: 'Supprimer',
    cancelDelete: 'Annuler',
    tents: 'Tentes',
    capacity: 'Capacité',
    occupancyRate: 'Taux d’occupation',
    occupiedTotal: 'Occupé / Total',
    percentage: 'Pourcentage',
    viewDetails: 'Voir les détails',
    exportTitle: 'Télécharger l’hébergement',
    exportButton: 'Télécharger l’hébergement',
  },
  settingsPage: {
    headerTitle: 'Paramètres',
    headerSubtitle: 'Gérer les paramètres du compte',
    changePasswordTitle: 'Changer le mot de passe',
    currentPasswordLabel: 'Mot de passe actuel',
    newPasswordLabel: 'Nouveau mot de passe',
    newPasswordPlaceholder: 'Entrez un nouveau mot de passe',
    updateButton: 'Mettre à jour le mot de passe',
    updating: 'Mise à jour en cours...',
    newPasswordRequired: 'Veuillez entrer un nouveau mot de passe',
    passwordLengthError: 'Le mot de passe doit contenir au moins 6 caractères',
    updateSuccess: 'Mot de passe mis à jour avec succès',
    updateError: 'Échec de la mise à jour du mot de passe',
    recentLoginRequired:
      'Veuillez vous déconnecter et vous reconnecter pour mettre à jour votre mot de passe',
    fetchError: 'Échec de la récupération des données utilisateur',
  },
  pilgrimSelector: {
    searchPlaceholder:
      'Rechercher par nom de pèlerin ou numéro de passeport...',
    passport: 'Passeport',
    package: 'Forfait',
    noResults: 'Aucun pèlerin ne correspond à la recherche',
    startSearch: 'Commencez à rechercher un pèlerin...',
  },
  campBedModal: {
    tent: 'Tente',
    hall: 'Salle',
    bed: 'Lit',
    noPermissionAssign: 'Vous n’avez pas la permission d’assigner des pèlerins',
    noPermissionRemove: 'Vous n’avez pas la permission de retirer un pèlerin',
    noPermissionManage: 'Vous n’avez pas la permission de gérer ce lit',
    assignSuccess: 'Pèlerin assigné avec succès',
    assignError: 'Échec de l’assignation du pèlerin',
    removeSuccess: 'Pèlerin retiré avec succès',
    removeError: 'Échec du retrait du pèlerin',
    removeButton: 'Retirer l’assignation',
    assignInstructions:
      'Veuillez sélectionner un pèlerin à assigner à ce lit. Assurez-vous que le pèlerin :',
    assignRule1: 'N’est pas assigné ailleurs',
    assignRule2: 'Correspond au type de salle ({gender})',
    assignRule3: 'Est lié à un guide approuvé',
    male: 'Homme',
    female: 'Femme',
  },
  campDetails: {
    notFound: 'Tableau d’hébergement introuvable',
    stats: {
      totalTents: 'Total des tentes',
      totalHalls: 'Total des salles',
      occupiedBeds: 'Lits occupés',
      occupancyRate: 'Taux d’occupation',
    },
    filters: {
      searchPlaceholder: 'Rechercher par numéro de tente ou nom de pèlerin...',
      allGenders: 'Tous les genres',
      male: 'Homme',
      female: 'Femme',
      allOccupancy: 'Tous les statuts',
      occupied: 'Occupé',
      available: 'Disponible',
    },
    tentHeader: 'Tente',
    hallHeader: 'Salle',
    available: 'Disponible',
  },
  room: {
    roomTypes: {
      double: 'Double',
      triple: 'Triple',
      quadruple: 'Quadruple',
    },
  },
  pilgrimsTable: {
    searchPlaceholder: 'Rechercher par nom ou ID de la plateforme Nusk...',
    exportButton: 'Exporter en Excel',
    activeFilters: 'Filtres actifs',
    filters: {
      allGenders: 'Tous les genres',
      male: 'Homme',
      female: 'Femme',
      allRoomTypes: 'Tous les types de chambres',
      double: 'Double',
      triple: 'Triple',
      quadruple: 'Quadruple',
      search: 'Rechercher',
      gender: 'Genre',
      roomType: 'Type de chambre',
    },
    tableHeaders: {
      pilgrim: 'Pèlerin',
      packageInfo: 'Informations sur le forfait',
      flightInfo: 'Informations sur le vol',
      accommodation: 'Hébergement',
      contact: 'Contact',
      passport: 'Passeport',
      serialNumber: 'ID de la plateforme Nusk',
      pnr: 'PNR',
      ticket: 'Billet',
      mainMakkahRoom: 'Chambre principale à La Mecque',
      shiftingMakkahRoom: 'Chambre de transition à La Mecque',
      madinahRoom: 'Chambre à Médine',
      residence: 'Résidence',
      nationality: 'Nationalité',
    },
    pagination: {
      page: 'Page',
      of: 'sur',
      pilgrims: 'Pèlerins',
    },
  },
  roomDetailsModal: {
    room: 'Chambre',
    roomInfo: 'Informations sur la chambre',
    occupancy: 'Occupation',
    pilgrims: 'Pèlerins',
    bed: 'Lit',
    guide: 'Guide',
    noPilgrims: 'Aucun pèlerin dans cette chambre',
    roomTypes: {
      double: 'Double',
      triple: 'Triple',
      quadruple: 'Quadruple',
    },
  },
  landing: {
    hero: {
      title: 'Système de gestion du Hajj et de la Omra',
      subtitle: 'Intégré',
      description:
        'Organisez vos opérations efficacement grâce à notre plateforme intégrée de gestion de l’hébergement, du transport et des services aux pèlerins',
      cta: 'Accéder au système',
    },
    features: {
      title: 'Fonctionnalités principales',
      accommodation: {
        title: 'Gestion de l’hébergement',
        description:
          'Gérez efficacement l’hébergement des pèlerins grâce à un système de logement avancé',
      },
      movement: {
        title: 'Coordination des déplacements',
        description:
          'Suivez et coordonnez les déplacements des pèlerins en temps réel',
      },
      camp: {
        title: 'Gestion des camps',
        description:
          'Outils complets pour la gestion des camps et des installations des pèlerins',
      },
      services: {
        title: 'Services aux pèlerins',
        description:
          'Fournissez des services de manière fluide pour répondre à tous les besoins des pèlerins',
      },
    },
    benefits: {
      title: 'Avantages du système',
      satisfaction: 'Satisfaction des clients',
      pilgrims: 'Pèlerins',
      support: 'Support continu',
      features: 'Fonctionnalités intégrées',
    },
    systemFeatures: {
      title: 'Fonctionnalités intégrées du système',
      hotel: {
        title: 'Gestion des hôtels',
        description:
          'Gestion visuelle interactive des chambres et de l’occupation hôtelière',
      },
      flight: {
        title: 'Gestion des vols',
        description:
          'Coordonnez les réservations de vols et gérez les horaires',
      },
      task: {
        title: 'Suivi des tâches',
        description: 'Gestion complète des tâches et suivi des progrès',
      },
      guide: {
        title: 'Affectation des guides',
        description:
          'Système efficace pour l’affectation et la gestion des guides',
      },
    },
    finalCta: {
      title: 'Prêt à commencer ?',
      description:
        'Accédez au tableau de bord pour gérer l’hébergement, les déplacements et les services aux pèlerins',
      cta: 'Accéder au système',
    },
    stats: {
      totalCamps: 'Total des camps',
      occupiedTents: 'Tentes occupées',
      totalCapacity: 'Capacité totale',
      occupancyRate: 'Taux d’occupation',
      pilgrims: 'Pèlerins',
      camps: 'Camps',
      capacity: 'Capacité',
      rate: 'Taux',
    },
    systemBenefits: {
      title: 'Avantages du système',
      efficiency: {
        title: 'Haute efficacité',
        description: 'Gestion fluide et efficace de toutes les opérations',
      },
      realTime: {
        title: 'Mises à jour en temps réel',
        description: 'Suivez les données et les déplacements en temps réel',
      },
      integration: {
        title: 'Intégration complète',
        description: 'Un système intégré qui relie tous les services',
      },
      support: {
        title: 'Support technique 24/7',
        description: 'Équipe de support disponible à tout moment',
      },
    },
    mainFeatures: {
      title: 'Fonctionnalités principales',
      accommodation: {
        title: 'Gestion de l’hébergement',
        description: 'Gérez efficacement les logements des pèlerins',
      },
      transportation: {
        title: 'Gestion du transport',
        description:
          'Organisez les déplacements des pèlerins entre les sites sacrés',
      },
      tasks: {
        title: 'Gestion des tâches',
        description: 'Suivez et gérez les tâches des pèlerins et des équipes',
      },
      guides: {
        title: 'Gestion des guides',
        description: 'Affectez et suivez les guides pour les pèlerins',
      },
    },
  },
  auth: {
    loginTitle: 'Connexion',
    email: 'E-mail',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    login: 'Se connecter',
    loggingIn: 'Connexion en cours...',
    loginSuccess: 'Connexion réussie',
    loginError: 'Échec de la connexion. Veuillez vérifier votre e-mail et mot de passe.',
    resetPassword: 'Réinitialiser le mot de passe',
    resetInstructions: 'Entrez votre adresse e-mail et nous vous enverrons des instructions pour réinitialiser votre mot de passe.',
    emailRequired: 'L\'e-mail est requis',
    resetSuccess: 'E-mail de réinitialisation envoyé. Veuillez vérifier votre boîte de réception.',
    resetError: 'Échec de l\'envoi de l\'e-mail de réinitialisation. Veuillez réessayer.',
    cancel: 'Annuler',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    sending: 'Envoi en cours...',
    collaborationMessage: 'Propulsé par notre partenariat pour l\'excellence',
    collaborationSubtext: 'Apporter l\'innovation aux services du Hajj',
    ithraaLogoAlt: 'Ithraa Al Khair',
    rehabLogoAlt: 'Société Rehab',
    copyright: '© 2025 Tous droits réservés à la société Rehab',
    poweredBy: 'Système développé par la société Rehab'
  },
  authh: {
    logout: 'Déconnexion',
  },
  components: {
    header: {
      userInfo: {
        organizerName: 'Nom de l’organisateur',
        gender: {
          male: 'Homme',
          female: 'Femme',
        },
      },
      logout: 'Déconnexion',
    },
  },
  dashboard: {
    title: 'Tableau de bord',
    stats: {
      totalMembers: 'Total des membres',
      activeMembers: 'Membres actifs',
      suspendedMembers: 'Membres suspendus',
    },
    recentActivity: {
      title: 'Activités récentes',
      types: {
        login: 'Connexion',
        update: 'Mise à jour des données',
        create: 'Ajouter un nouveau membre',
      },
    },
  },
  team: {
    title: 'Équipe',
    addMember: 'Ajouter un nouveau membre',
    search: {
      placeholder: 'Rechercher par nom d’utilisateur ou e-mail...',
      filters: {
        title: 'Filtres actifs',
        allRoles: 'Tous les rôles',
        allGenders: 'Tous les genres',
        allStatuses: 'Tous les statuts',
        male: 'Homme',
        female: 'Femme',
        active: 'Actif',
        suspended: 'Suspendu',
        clearFilters: 'Effacer les filtres',
      },
    },
    noResults: 'Aucun utilisateur ne correspond aux filtres sélectionnés',
    form: {
      title: {
        add: 'Ajouter un nouveau membre',
        edit: 'Modifier les détails du membre',
        selectRole: 'Sélectionner un rôle',
      },
      fields: {
        name: 'Nom',
        email: 'E-mail',
        password: 'Mot de passe',
        gender: 'Genre',
        role: 'Rôle',
        status: 'Statut',
      },
      buttons: {
        save: 'Enregistrer',
        saving: 'Enregistrement en cours...',
        cancel: 'Annuler',
      },
      validation: {
        required: 'Ce champ est obligatoire',
        emailInvalid: 'E-mail invalide',
        passwordLength: 'Le mot de passe doit contenir au moins 6 caractères',
      },
    },
    delete: {
      title: 'Supprimer le membre',
      message:
        'Êtes-vous sûr de vouloir supprimer le membre "{name}" ? Cette action est irréversible.',
      confirm: 'Supprimer',
      cancel: 'Annuler',
    },
    messages: {
      addSuccess: 'Membre ajouté avec succès',
      addError: 'Échec de l’ajout du membre',
      updateSuccess: 'Détails du membre mis à jour avec succès',
      updateError: 'Échec de la mise à jour des détails du membre',
      deleteSuccess: 'Membre supprimé avec succès',
      deleteError: 'Échec de la suppression du membre',
    },
  },
  roles: {
    title: 'Rôles et permissions',
    addRole: 'Ajouter un nouveau rôle',
    labels: {
      admin: 'Administrateur système',
      guide: 'Guide',
      organizer: 'Organisateur',
    },
    form: {
      title: {
        add: 'Ajouter un nouveau rôle',
        edit: 'Modifier le rôle',
      },
      fields: {
        name: 'Nom du rôle',
        permissions: 'Permissions',
      },
      sections: {
        dashboard: 'Tableau de bord',
        team: 'Équipe',
        roles: 'Rôles et permissions',
      },
      validation: {
        required: 'Ce champ est obligatoire',
        selectPermissions: 'Au moins une permission doit être sélectionnée',
      },
      buttons: {
        save: 'Enregistrer',
        saving: 'Enregistrement en cours...',
        cancel: 'Annuler',
      },
    },
    permissions: {
      title: 'Permissions',
      create: 'Créer',
      read: 'Lire',
      update: 'Mettre à jour',
      delete: 'Supprimer',
    },
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
    },
    delete: {
      title: 'Supprimer le rôle',
      message:
        'Êtes-vous sûr de vouloir supprimer le rôle "{name}" ? Cette action est irréversible.',
      confirm: 'Supprimer',
      cancel: 'Annuler',
    },
    messages: {
      addSuccess: 'Rôle ajouté avec succès',
      addError: 'Échec de l’ajout du rôle',
      updateSuccess: 'Rôle mis à jour avec succès',
      updateError: 'Échec de la mise à jour du rôle',
      deleteSuccess: 'Rôle supprimé avec succès',
      deleteError: 'Échec de la suppression du rôle',
    },
  },
  organizers: {
    title: 'Organisateurs',
    addOrganizer: 'Ajouter un nouvel organisateur',
    form: {
      title: {
        add: 'Ajouter un nouvel organisateur',
        edit: 'Modifier les détails de l’organisateur',
      },
      fields: {
        name: 'Nom',
        email: 'E-mail',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
      },
      validation: {
        required: 'Ce champ est obligatoire',
        emailInvalid: 'E-mail invalide',
        passwordLength: 'Le mot de passe doit contenir au moins 6 caractères',
        passwordsNotMatch: 'Les mots de passe ne correspondent pas',
      },
      buttons: {
        save: 'Enregistrer',
        saving: 'Enregistrement en cours...',
        cancel: 'Annuler',
      },
    },
    table: {
      name: 'Organisateur',
      email: 'E-mail',
      password: 'Mot de passe',
      actions: 'Actions',
    },
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
      resetPassword: 'Changer le mot de passe',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
      copyEmail: 'Copier l’e-mail',
      copyPassword: 'Copier le mot de passe',
    },
    messages: {
      addSuccess: 'Organisateur ajouté avec succès',
      addError: 'Échec de l’ajout de l’organisateur',
      updateSuccess: 'Détails de l’organisateur mis à jour avec succès',
      updateError: 'Échec de la mise à jour des détails de l’organisateur',
      deleteSuccess: 'Organisateur supprimé avec succès',
      deleteError: 'Échec de la suppression de l’organisateur',
      resetSuccess: 'Mot de passe changé avec succès',
      resetError: 'Échec du changement de mot de passe',
      copySuccess: 'Copié avec succès',
      copyError: 'Échec de la copie',
    },
    delete: {
      title: 'Supprimer l’organisateur',
      message:
        'Êtes-vous sûr de vouloir supprimer l’organisateur "{name}" ? Cette action est irréversible.',
      confirm: 'Supprimer',
      cancel: 'Annuler',
    },
    resetPassword: {
      title: 'Changer le mot de passe',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
    },
  },
  management: {
    title: 'Gestion',
  },
  menu: {
    dashboard: 'Tableau de bord',
    pilgrims: 'Pèlerins',
    packages: 'Forfaits',
    flights: 'Vols',
    verification: 'Vérification',
    pilgrimGuide: 'Lier les pèlerins',
    linkingStatus: 'Statut de liaison',
    disputes: 'Litiges',
    accommodationTasks: 'Tâches d’hébergement',
    accommodation: 'Hébergement',
    hotelVisualization: 'Visualisation des hôtels',
    team: 'Équipe',
    roles: 'Rôles et permissions',
    organizers: 'Organisateurs',
    guides: 'Guides',
    movements: 'Calendrier des déplacements',
    campAccommodation: 'Hébergement en camp',
    accommodationLogs: 'Journal des Hébergements',
    settings: 'Paramètres',
    bans: 'Gestion des interdictions',
    pilgrimOwnership: 'Propriété des Pèlerins',
    organizerFinance: 'Finance des Organisateurs',
    verificationWizard: "Contrat du guide/de l'organisateur",
    verificationApproval: 'Contrats des organisateurs/guide',
  },
  menuGroups: {
    dashboard: 'Tableau de bord',
    management: 'Gestion des données',
    linking: 'Liaison',
    accommodation: 'Hébergement',
    settings: 'Paramètres',
  },
  pilgrimGuide: {
    header: 'Lier les pèlerins aux guides',
    guideDescription: 'Ajoutez des pèlerins à votre liste de supervision.',
    adminDescription:
      'Lie les pèlerins aux guides appropriés et gérez leur relation.',
    addButton: 'Ajouter un pèlerin',
    linkButton: 'Lier un pèlerin à un guide',
  },
  accommodation: {
    header: 'Hébergement en hôtel',
    description: 'Gérez l’hébergement des pèlerins dans les hôtels',
    addButton: 'Ajouter un tableau d’hébergement',
    noTables: 'Aucun tableau d’hébergement disponible',
    errors: {
      serviceSuspended: "Le service d'hébergement est actuellement suspendu",
      hotelSuspended: 'Cet hôtel est actuellement suspendu',
      notAuthenticated: "Vous n'êtes pas authentifié",
      notAuthorized: "Vous n'êtes pas autorisé à effectuer cette action",
      userBanned: "Vous êtes interdit d'utiliser le service d'hébergement",
      packageNotFound: 'Forfait non trouvé pour le pèlerin',
      hotelNotAssigned: "Cet hôtel n'est pas attribué au forfait du pèlerin",
      pilgrimNotFound: 'Aucun pèlerin trouvé avec ce numéro de passeport',
      noGuideLinked: "Le pèlerin n'est lié à aucun guide",
      noPermission: "Vous n'avez pas la permission d'effectuer cette action",
      tableNotFound: "Table d'hébergement non trouvée",
      roomNotFound: 'Chambre non trouvée',
      roomNumberExists: 'Le numéro de chambre existe déjà',
      commentTextRequired: 'Le texte du commentaire est requis',
      userInfoRequired: 'Les informations utilisateur sont requises',
      noComments: 'Aucun commentaire trouvé',
      invalidRoomNumber: 'Numéro de chambre invalide',
      invalidRoomType: 'Type de chambre invalide',
      excelParseError:
        'Échec de la lecture du fichier Excel. Veuillez vérifier les données',
    },
  },
  pilgrimGuideDetails: {
    header: {
      basicInfo: 'Informations sur le pèlerin',
      contactInfo: 'Informations de contact',
      locationInfo: 'Informations sur l’hébergement',
      hotelInfo: 'Informations sur l’hôtel',
      mainMakkahHotel: 'Hôtel principal à La Mecque',
      shiftingMakkahHotel: 'Hôtel de transition à La Mecque',
      madinahHotel: 'Hôtel à Médine',
    },
    labels: {
      name: 'Nom',
      passport: 'Numéro de passeport',
      gender: {
        male: 'Homme',
        female: 'Femme',
      },
      age: 'Âge',
      mobile: 'Numéro de portable',
      email: 'E-mail',
      residenceCountry: 'Pays de résidence',
      nationality: 'Nationalité',
      hotelName: 'Nom de l’hôtel',
      roomType: 'Type de chambre',
      roomNumber: 'Numéro de chambre',
      years: 'Années',
    },
  },
  statusBadge: {
    statuses: {
      approved: 'Approuvé',
      disputed: 'En litige',
      rejected: 'Rejeté',
      pending: 'En attente',
      waitingIdentification: 'En attente d’identification',
    },
    actions: {
      viewEvidence: 'Voir la preuve',
      editEvidence: 'Modifier',
      submitEvidence: 'Soumettre la preuve',
    },
  },
  linkingTable: {
    filters: {
      searchPlaceholder:
        'Rechercher par nom de pèlerin ou numéro de passeport...',
      allStatuses: 'Tous les statuts',
      approved: 'Approuvé',
      pending: 'En attente',
      rejected: 'Rejeté',
      waitingIdentification: 'En attente d’identification',
      allCountries: 'Tous les pays',
      activeFilters: 'Filtres actifs',
      search: 'Rechercher',
      status: 'Statut',
      country: 'Pays',
    },
    tableHeaders: {
      pilgrim: 'Informations sur le pèlerin',
      package: 'Forfait',
      guideAndOrganizer: 'Guide et organisateur',
      status: 'Statut',
    },
    pagination: {
      page: 'Page',
      of: 'sur',
      pilgrimsCount: 'Pèlerins',
    },
  },
  packageInfo: {
    pilgrimType: 'Type de pèlerin',
    nusukGroup: 'Groupe Nusuk',
  },
  pilgrimGuideTable: {
    headers: {
      pilgrimInfo: 'Informations sur le pèlerin',
      package: 'Forfait',
      guideAndOrganizer: 'Guide et organisateur',
      status: 'Statut',
    },
    pagination: {
      page: 'Page',
      of: 'sur',
      pilgrimCount: 'Pèlerins',
    },
  },
  pilgrimInfo: {
    passport: 'Passeport',
  },
  filters: {
    searchPlaceholder:
      'Rechercher par nom de pèlerin, numéro de passeport ou PNR...',
    allGenders: 'Tous les genres',
    allCountries: 'Tous les pays',
    male: 'Homme',
    female: 'Femme',
    allNationalities: 'Toutes les nationalités',
    unitedKingdom: 'Royaume-Uni',
    malaysia: 'Malaisie',
    indonesia: 'Indonésie',
    allPackages: 'Tous les types de forfaits',
    mainPackage: 'Principal',
    shiftingPackage: 'Transitionnel',
    allHotels: 'Tous les hôtels',
    vocoHotel: 'Hôtel Voco',
    hiltonHotel: 'Hôtel Hilton',
    marriottHotel: 'Hôtel Marriott',
    allStatuses: 'Tous les statuts',
    approved: 'Approuvé',
    pending: 'En attente',
    rejected: 'Rejeté',
    activeFilters: 'Filtres actifs',
    search: 'Rechercher',
    gender: 'Genre',
    nationality: 'Nationalité',
    packageType: 'Type de forfait',
    hotel: 'Hôtel',
    status: 'Statut',
    clearFilters: 'Effacer les filtres',
  },
  statusFilter: {
    allStatuses: 'Tous les statuts',
    approved: 'Approuvé',
    pending: 'En attente',
    rejected: 'Rejeté',
    disputed: 'En litige',
    waitingIdentification: 'En attente d’identification',
  },
  searchInput: {
    placeholder: 'Rechercher par nom de pèlerin ou numéro de passeport...',
  },
  statistics: {
    rooms: 'Chambres',
    occupiedTotal: 'Occupé / Total',
    beds: 'Lits',
    occupiedCapacity: 'Occupé / Capacité',
    occupancyRate: 'Taux d’occupation',
    percentage: 'Pourcentage',
  },
  actions: {
    viewDetails: 'Voir les détails',
    download: 'Télécharger l’hébergement',
    deleteTable: 'Supprimer le tableau',
  },
  messages: {
    exportSuccess: 'Données d’hébergement exportées avec succès',
    exportError: 'Échec de l’exportation des données d’hébergement',
    deleteSuccess: 'Tableau d’hébergement supprimé avec succès',
    deleteError: 'Échec de la suppression du tableau d’hébergement',
  },
  confirmDialog: {
    deleteTitle: 'Supprimer le tableau d’hébergement',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer le tableau "{name}" ?',
    delete: 'Supprimer',
    cancel: 'Annuler',
  },
  roomStats: {
    rooms: 'Statistiques des chambres',
    occupiedTotal: 'Occupé / Total',
    beds: 'Statistiques des lits',
    occupiedCapacity: 'Occupé / Capacité',
    guestDistribution: 'Répartition des invités',
    male: 'Hommes',
    female: 'Femmes',
    occupancyRate: 'Taux d’occupation',
    highOccupancy: 'Occupation élevée',
    mediumOccupancy: 'Occupation moyenne',
    lowOccupancy: 'Occupation faible',
  },
  roomTable: {
    headers: {
      roomNumber: 'Numéro de chambre',
      roomType: 'Type de chambre',
      capacity: 'Capacité',
      occupancy: 'Occupation',
      actions: 'Voir',
    },
    roomTypes: {
      double: 'Double',
      triple: 'Triple',
      quad: 'Quadruple',
    },
  },
  roomTableRow: {
    roomTypes: {
      double: 'Chambre double',
      triple: 'Chambre triple',
      quadruple: 'Chambre quadruple',
    },
    capacity: 'Capacité',
    statuses: {
      available: 'Disponible',
      full: 'Complet',
      partial: 'Partiellement disponible',
      availableBed: 'Lit disponible',
    },
    years: 'Années',
    actions: {
      viewDetails: 'Voir les détails',
    },
  },
  errors: {
    loadRoom: 'Échec du chargement des détails de la chambre',
    assignPermission: 'Vous n’avez pas la permission d’assigner des pèlerins',
    removePermission: 'Vous n’avez pas la permission de retirer des pèlerins',
    invalidRoomNumber: 'Veuillez entrer un numéro de chambre valide',
    assignFailed: 'Échec de l’assignation du pèlerin',
    removeFailed: 'Échec du retrait du pèlerin',
    updateRoomNumber: 'Échec de la mise à jour du numéro de chambre',
    emptyComment: 'Le texte du commentaire est requis',
    notLoggedIn: 'Vous devez vous connecter pour ajouter un commentaire',
    addComment: 'Échec de l’ajout du commentaire',
    deleteComment: 'Échec de la suppression du commentaire',
  },
  success: {
    assignPilgrim: 'Pèlerin assigné avec succès',
    removePilgrim: 'Pèlerin retiré avec succès',
    updateRoomNumber: 'Numéro de chambre mis à jour avec succès',
    addComment: 'Commentaire ajouté avec succès',
    deleteComment: 'Commentaire supprimé avec succès',
  },
  roomViewModal: {
    title: 'Chambre',
    editTitle: 'Modifier le numéro de chambre',
    placeholder: 'Entrez le nouveau numéro de chambre',
    roomType: 'Type de chambre',
    double: 'Double',
    triple: 'Triple',
    quadruple: 'Quadruple',
    bedsCount: 'Nombre de lits',
    assignNew: 'Assigner un nouveau pèlerin',
  },
  pilgrimCard: {
    bed: 'Lit',
    years: 'Années',
    checkIn: "Date d'arrivée",
    checkOut: 'Date de départ',
    remove: "Retirer l'assignation",
    assignNew: 'Assigner un nouveau pèlerin',
    guide: 'Guide',
  },
  commentSection: {
    header: 'Commentaires et notes',
    delete: 'Supprimer le commentaire',
    placeholder: 'Écrivez un commentaire...',
  },
  roomFilters: {
    placeholders: {
      search: 'Rechercher par numéro de chambre...',
    },
    options: {
      allRoomTypes: 'Tous les types de chambres',
      double: 'Double',
      triple: 'Triple',
      quadruple: 'Quadruple',
      allStatuses: 'Tous les statuts',
      occupied: 'Occupée',
      available: 'Disponible',
      partial: 'Partiellement occupée',
    },
    activeFilters: 'Filtres actifs',
    labels: {
      search: 'Rechercher',
      roomType: 'Type de chambre',
      status: 'Statut',
    },
  },
  accommodationTasks: {
    header: 'Tâches d’hébergement',
    subheader: 'Suivi de l’état de l’hébergement des pèlerins dans les hôtels',
    stats: {
      totalPilgrims: 'Total des pèlerins',
      accommodated: 'Hébergés',
      pending: 'En attente',
      completionRate: 'Taux d’achèvement',
    },
    filters: {
      title: 'Options de filtrage',
    },
    noResults: 'Aucun pèlerin ne correspond aux filtres sélectionnés',
  },
  tasksFilters: {
    searchPlaceholder: 'Rechercher par nom de pèlerin ou pays...',
    gender: {
      all: 'Tous les genres',
      male: 'Homme',
      female: 'Femme',
    },
    status: {
      all: 'Tous les statuts',
      completed: 'Hébergé',
      pending: 'En attente',
    },
    activeFilters: 'Filtres actifs :',
    labels: {
      search: 'Rechercher',
      gender: 'Genre',
      status: 'Statut',
    },
  },
  accommodationTasksList: {
    headers: {
      pilgrim: 'Pèlerin',
      package: 'Forfait',
      mainMakkah: 'Hôtel principal à La Mecque',
      shiftingMakkah: 'Hôtel de transition à La Mecque',
      madinah: 'Hôtel à Médine',
    },
    room: 'Chambre',
  },
  common: {
    notSpecified: 'Non spécifié',
    notAvailable: 'Non disponible',
    pilgrims: 'Pèlerins',
    delete: 'Supprimer',
    cancel: 'Annuler',
    loading: 'Chargement en cours...',
    error: 'Une erreur s’est produite lors du chargement',
  },
  pagination: {
    page: 'Page',
    of: 'sur',
  },
  recentPilgrims: {
    title: 'Derniers pèlerins ajoutés',
    statuses: {
      approved: 'Approuvé',
      disputed: 'En litige',
      pending: 'En attente',
    },
  },
  organizerStats: {
    totalGuides: 'Guides',
    totalPilgrims: 'Total des pèlerins',
    pendingLinks: 'Demandes de liaison',
    disputes: 'Litiges',
  },
  guidesPage: {
    title: 'Guides',
    organizerDescription: 'Gérez les guides sous votre organisation',
    adminDescription: 'Gérez tous les guides dans le système',
  },
  guidesList: {
    title: 'Guides',
    addButton: 'Ajouter un guide',
    resetPassword: 'Réinitialiser le mot de passe',
    deleteTitle: 'Supprimer le guide',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer le guide "{name}" ?',
    noGuides: 'Aucun guide disponible',
  },
  pilgrimGuideList: {
    noPilgrims: 'Aucun pèlerin lié pour le moment',
  },
  addGuideModal: {
    title: 'Ajouter un nouveau guide',
    requiredFields: 'Tous les champs sont obligatoires',
    successMessage: 'Guide ajouté avec succès',
    errorMessage: 'Une erreur s’est produite lors de l’ajout du guide',
    toastError: 'Échec de l’ajout du guide',
  },
  guideForm: {
    labels: {
      name: 'Nom',
      email: 'E-mail',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
    },
    errors: {
      name: 'Ce champ est obligatoire',
      emailRequired: 'Ce champ est obligatoire',
      invalidEmail: 'E-mail invalide',
      passwordRequired: 'Ce champ est obligatoire',
      passwordLength: 'Le mot de passe doit contenir au moins 6 caractères',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
    },
    submit: 'Enregistrer',
    loading: 'Enregistrement en cours...',
  },
  addPilgrimModal: {
    titleGuide: 'Ajouter un pèlerin',
    titleAdminOrganizer: 'Lier un pèlerin à un guide',
    passportError: 'Veuillez entrer un numéro de passeport',
    guideError: 'Veuillez sélectionner un guide',
    pilgrimNotFound: 'Aucun pèlerin trouvé avec ce numéro',
    guideNotFound: 'Guide non trouvé',
    unauthorized: 'Opération non autorisée',
    success: 'Pèlerin ajouté avec succès',
    waitingIdentificationSuccess: 'Pèlerin ajouté et en attente d’identification',
    addButton: 'Ajouter',
    addingButton: 'Ajout en cours...',
    cancelButton: 'Annuler',
  },
  pilgrimAssignment: {
    errorNoPassport: 'Veuillez entrer un numéro de passeport',
    errorAssign: 'Échec de l’assignation du pèlerin',
    placeholder: 'Entrez le numéro de passeport',
    submitLoading: 'Vérification en cours...',
    submit: 'Assigner le pèlerin',
  },
  passportInput: {
    label: 'Numéro de passeport',
    requiredMark: '*',
    placeholder: 'Entrez le numéro de passeport',
    loading: 'Chargement en cours...',
  },
  guideSearch: {
    label: 'Guide',
    requiredMark: '*',
    placeholder: 'Rechercher par nom de guide ou e-mail...',
    noGuidesFound: 'Aucun guide disponible',
    noMatchingGuides: 'Aucun guide ne correspond à la recherche',
  },
  hotelVisualizationPage: {
    headerTitle: 'Visualisation des hôtels',
    headerSubtitle:
      'Afficher les détails des hôtels, des bâtiments et des chambres',
    hotelSelectionTitle: 'Sélectionner un hôtel',
    buildingSelectionTitle: 'Sélectionner un bâtiment',
  },
  buildingView: {
    floorNavigationTitle: 'Étages',
    floorNavigationSubtitle: 'Sélectionnez un étage pour afficher ses détails',
  },
  hotelFloor: {
    floorLabel: 'Étage',
  },
  hotelSelector: {
    singleBuilding: 'Un seul bâtiment',
    multipleBuildings: '{count} bâtiments',
  },
  guideStats: {
    registeredPilgrims: 'Pèlerins enregistrés',
    accommodatedPilgrims: 'Hébergés',
    pendingPilgrims: 'En attente',
    disputes: 'Litiges',
  },
  bedList: {
    available: 'Disponible pour assignation !',
    bed: 'Lit',
    assign: 'Assigner un pèlerin',
  },
};
